import { ConditionDescription } from '@contracts';

export const conditionPainArray: ConditionDescription[] = [
  { description: 'Started with one of your very first periods', relatedConditions: ['PD'] },
  {
    description: 'Started years after your first period',
    relatedConditions: ['endometriosis', 'PCOS', 'fibroids', 'PID', 'adenomyosis']
  },
  {
    description: 'Occurs just before AND/OR during your period',
    relatedConditions: ['endometriosis', 'PD', 'PCOS', 'fibroids', 'PID', 'adenomyosis']
  },
  {
    description: 'Occurs after your period',
    relatedConditions: ['endometriosis', 'fibroids', 'PID', 'adenomyosis']
  },
  {
    description: 'Is unpredictable and occurs throughout your cycle',
    relatedConditions: ['endometriosis', 'fibroids', 'PID', 'adenomyosis']
  },
  {
    description: 'Is very intense',
    relatedConditions: ['endometriosis', 'PCOS', 'fibroids', 'PID', 'adenomyosis']
  },
  { description: 'Lasts for less than 3 days', relatedConditions: ['PD'] },
  {
    description: 'Lasts for more than 3 days or duration is unpredictable',
    relatedConditions: ['endometriosis', 'PCOS', 'fibroids', 'PID', 'adenomyosis']
  },
  { description: 'Comes and goes in waves', relatedConditions: ['PD'] },
  { description: 'Feels like pressure in the pelvis', relatedConditions: ['endometriosis', 'fibroids'] },
  {
    description: 'Radiates to your lower back',
    relatedConditions: ['endometriosis', 'PD', 'adenomyosis']
  },
  {
    description: 'Radiates to other parts of your body (legs, rectum or groin)',
    relatedConditions: ['endometriosis', 'PCOS', 'fibroids', 'PID', 'adenomyosis']
  },
  { description: 'Radiates to your shoulder', relatedConditions: ['endometriosis'] },
  { description: 'Is only felt in your abdomen', relatedConditions: ['PD'] }
];

export const conditionSignsAndSymptomsArray: ConditionDescription[] = [
  { description: 'Getting your first period before the age of 10', relatedConditions: ['endometriosis'] },
  { description: 'Regular periods', relatedConditions: ['PD'] },
  { description: 'Irregular periods', relatedConditions: ['PCOS', 'fibroids', 'adenomyosis'] },
  { description: 'Rare or no periods', relatedConditions: ['PCOS'] },
  { description: 'Very heavy periods', relatedConditions: ['endometriosis', 'fibroids', 'adenomyosis'] },
  {
    description: 'If menstruating, cycle is shorter or longer than usual (less than 21 days or more than 32 days)',
    relatedConditions: ['PCOS']
  },
  { description: 'Cycle length is between 21 and 31 days', relatedConditions: ['PD'] },
  { description: 'Periods last between 3 and 8 days', relatedConditions: ['PD'] },
  {
    description: 'Menstruation lasts more than 8 days',
    relatedConditions: ['endometriosis', 'fibroids', 'adenomyosis']
  },
  { description: 'Clotting', relatedConditions: ['adenomyosis'] },
  {
    description: 'Bloating',
    relatedConditions: ['endometriosis', 'PD', 'fibroids', 'adenomyosis']
  },
  { description: 'Feeling sick (nausea or vomitting)', relatedConditions: ['PID'] },
  { description: 'Headaches or migraines', relatedConditions: ['PD'] },
  { description: 'No symptoms of pelvic pain conditions', relatedConditions: [] },
  { description: 'Need to pee frequently', relatedConditions: ['fibroids'] },
  {
    description: 'Spotting or bleeding outside my period',
    relatedConditions: ['endometriosis', 'fibroids', 'PID']
  },
  { description: 'Burning sensation in the vagina', relatedConditions: ['PID'] },
  { description: 'Pain/burning while peeing', relatedConditions: ['endometriosis', 'PID'] },
  { description: 'Pain/burning during bowel movements', relatedConditions: ['endometriosis', 'adenomyosis'] },
  {
    description: 'Pain during penetrative sex',
    relatedConditions: ['endometriosis', 'PID', 'adenomyosis']
  },
  { description: 'Bleeding after sex', relatedConditions: ['endometriosis', 'PID'] },
  { description: 'Vulval discomfort (itchiness, pain, redness, or swelling)', relatedConditions: ['PID'] },
  { description: 'Vaginal discomfort (itchiness, pain, or swelling)', relatedConditions: ['PID'] },
  { description: 'Unusual vaginal discharge (heavy or with unusual odour)', relatedConditions: ['PID'] },
  { description: 'Severe acne', relatedConditions: ['PCOS'] },
  { description: 'Hair loss', relatedConditions: ['PCOS'] },
  { description: 'Excessive facial or body hair', relatedConditions: ['PCOS'] },
  { description: 'Constipation', relatedConditions: ['endometriosis', 'fibroids'] },
  { description: 'Fever (greater than 38°C)', relatedConditions: ['PID'] },
  { description: 'Weight gain or difficulty losing weight', relatedConditions: ['PCOS'] },
  { description: 'Fatigue', relatedConditions: ['endometriosis'] },
  { description: 'Diarrhoea', relatedConditions: ['PID'] },
  { description: 'No previous diagnosis of pelvic pain conditions', relatedConditions: [] },
  { description: 'Recent STI infection (Chlamydia, Gonorrhea, or Mycoplasma genitalium)', relatedConditions: [] },
  { description: 'History of insulin resistance or diabetes', relatedConditions: ['PCOS'] },
  { description: 'Family history of adenomyosis', relatedConditions: ['adenomyosis'] },
  { description: 'Family history of endometriosis', relatedConditions: ['endometriosis'] },
  { description: 'Family history of fibroids', relatedConditions: ['fibroids'] },
  { description: 'Family history of PCOS', relatedConditions: ['PCOS'] },
  {
    description: 'Difficulty getting pregnant',
    relatedConditions: ['endometriosis', 'PCOS', 'PID']
  },
  { description: 'History of miscarriage', relatedConditions: ['PCOS', 'adenomyosis'] },
  { description: 'History of ectopic pregnancy', relatedConditions: ['PID'] },
  {
    description: 'History of preterm labour',
    relatedConditions: ['fibroids', 'PID', 'adenomyosis']
  },
  { description: 'No previous pregnancies', relatedConditions: ['fibroids'] }
];
